import { useEffect, useState } from 'react';

const useIsScrolledToTop = (scrollRef, threshold = 0) => {
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);

  useEffect(() => {
    const element = scrollRef?.current;

    if (!element) {
      return undefined;
    }

    const handleScroll = () => {
      setIsScrolledToTop(element.scrollTop <= threshold);
    };

    handleScroll();
    element.addEventListener('scroll', handleScroll);

    return () => {
      element.removeEventListener('scroll', handleScroll);
    };
  }, [scrollRef, threshold]);

  return isScrolledToTop;
};

export default useIsScrolledToTop;
